import { onMounted, onUnmounted, toRaw } from 'vue'
import { FileActions } from '@/constants/actions'
import { eventBus, logger } from '@/instance'
import { useStore } from '@/store'
import { trackButtonClick } from '@/utils/analytics'

export function useAnalytics(): void {
  const store = useStore()
  const handleAnalytics = (...args: any[]) => {
    logger.log('composables/Analytics', 'handleAnalytics', args)
    trackButtonClick(args[1], { ...toRaw(args[0]&&args[0].data) })
  }
  const bind = () => {
    eventBus.on(FileActions.CREATE, handleAnalytics)
    eventBus.on(FileActions.CREATE_PROJECT, handleAnalytics)
    eventBus.on(FileActions.REVIEW_STATUS, handleAnalytics)
    eventBus.on(FileActions.COPY, handleAnalytics)
    eventBus.on(FileActions.MOVE, handleAnalytics)
    eventBus.on(FileActions.DELETE, handleAnalytics)
    eventBus.on(FileActions.DOWNLOAD, handleAnalytics)
    eventBus.on(FileActions.RENAME, handleAnalytics)
    eventBus.on(FileActions.UPLOAD_FILE, handleAnalytics)
    eventBus.on(FileActions.UPLOAD_FOLDER, handleAnalytics)
    eventBus.on(FileActions.PURGE, handleAnalytics)
    eventBus.on(FileActions.PURGE_ALL, handleAnalytics)
    eventBus.on(FileActions.RESTORE, handleAnalytics)
    eventBus.on(FileActions.SHARE, handleAnalytics)
    eventBus.on(FileActions.COLLECTION, handleAnalytics)
    eventBus.on(FileActions.INVITE_MEMBER, handleAnalytics)
    eventBus.on(FileActions.PAUSE_UPLOAD, handleAnalytics)
    eventBus.on(FileActions.RESUME_UPLOAD, handleAnalytics)
    eventBus.on(FileActions.CANCEL_UPLOAD, handleAnalytics)
    logger.log('composables/Analytics', 'unbind')
  }
  const unbind = () => {
    eventBus.off(FileActions.CREATE, handleAnalytics)
    eventBus.off(FileActions.CREATE_PROJECT, handleAnalytics)
    eventBus.off(FileActions.REVIEW_STATUS, handleAnalytics)
    eventBus.off(FileActions.COPY, handleAnalytics)
    eventBus.off(FileActions.MOVE, handleAnalytics)
    eventBus.off(FileActions.DELETE, handleAnalytics)
    eventBus.off(FileActions.DOWNLOAD, handleAnalytics)
    eventBus.off(FileActions.RENAME, handleAnalytics)
    eventBus.off(FileActions.UPLOAD_FILE, handleAnalytics)
    eventBus.off(FileActions.UPLOAD_FOLDER, handleAnalytics)
    eventBus.off(FileActions.PURGE, handleAnalytics)
    eventBus.off(FileActions.PURGE_ALL, handleAnalytics)
    eventBus.off(FileActions.RESTORE, handleAnalytics)
    eventBus.off(FileActions.SHARE, handleAnalytics)
    eventBus.off(FileActions.COLLECTION, handleAnalytics)
    eventBus.off(FileActions.INVITE_MEMBER, handleAnalytics)
    eventBus.off(FileActions.PAUSE_UPLOAD, handleAnalytics)
    eventBus.off(FileActions.RESUME_UPLOAD, handleAnalytics)
    eventBus.off(FileActions.CANCEL_UPLOAD, handleAnalytics)
    logger.log('composables/Analytics', 'unbind')
  }

  onMounted(bind)
  onUnmounted(unbind)
}
